/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import Nav from "./Navigation.js";

export default function WelcomePage() {
  return (
    <div>
      <Nav></Nav>
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="bg-darker border-card border-8 px-20 py-20">
          <div className="flex flex-col justify-center items-center">
            <p className="text-white text-[50px] font-Open font-mono">
              You are Logged Out!
            </p>
            <p className="text-white text-[50px] font-Open font-mono">
              Labyrinthine Unofficial Tracker
            </p>
            <div className="text-white">Website is in alpha phase</div>
            <br></br>
            <div>
              <div className="text-white">What is accessible:</div>
              <div className="text-white">
                -Quick access to in game information
              </div>
              <div className="text-white">
                -A tracking system for your cosmetics
              </div>
              <div className="text-white">-Continual updates</div>
              <div className="text-white">
                -Free Hugs to Anyone who Signs up!(hugs not included*)
              </div>
            </div>
            <div>
              <br></br>
              <br></br>
              <br></br>
              <Link
                className="m-2 p-8 text-white rounded-xl bg-gradient-to-br to-blue-500 via-black from-blue-500 bg-size-200 hover:bg-right-bottom"
                to="/login"
              >
                LOGIN
              </Link>
              <Link
                className="m-2 p-8 text-white rounded-xl bg-gradient-to-br to-purple-500 via-black from-purple-500 bg-size-200 hover:bg-right-bottom"
                to="/signup"
              >
                CREATE NEW ACCOUNT
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
